import { Button, Center, Divider, Modal, Stack, Text } from '@mantine/core'
import { useEffect, useRef, useState } from 'react'
import { QRCodeCanvas } from 'qrcode.react'
import { Toast } from 'antd-mobile'

interface WechatPayQRCodeModalProps {
  opened: boolean
  onClose: () => void
  url: string
}

export default function WechatPayQRCodeModal({ opened, onClose, url }: WechatPayQRCodeModalProps) {
  const [qrImageUrl, setQrImageUrl] = useState('')
  const canvasRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (opened && url) {
      setQrImageUrl('')
      setTimeout(() => {
        const canvas = canvasRef.current?.querySelector('canvas')
        if (canvas) {
          setQrImageUrl(canvas.toDataURL('image/png'))
        }
      }, 100)
    }
  }, [opened, url])

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(url)
      Toast.show('链接已复制，请打开微信粘贴访问')
    } catch {
      Toast.show('复制失败，请手动复制')
    }
  }

  return (
    <Modal opened={opened} onClose={onClose} title="微信支付" centered size="sm">
      <Stack gap="md" py="md">
        <Center>
          {qrImageUrl ? (
            <img src={qrImageUrl} alt="支付二维码" style={{ width: 180, height: 180 }} />
          ) : (
            <div ref={canvasRef}>
              <QRCodeCanvas value={url || 'loading'} size={180} />
            </div>
          )}
        </Center>

        <Divider label="方式一：长按保存二维码" labelPosition="center" />
        <Text size="xs" c="dimmed" ta="center">
          长按上方二维码保存到相册 → 打开微信扫一扫 → 从相册选择
        </Text>

        <Divider label="方式二：复制链接" labelPosition="center" />
        <Stack gap="xs">
          <Button variant="outline" color="blue" onClick={handleCopyLink}>
            复制链接
          </Button>
          <Text size="xs" c="dimmed" ta="center">
            复制后打开微信 → 粘贴链接发送给自己 → 点击打开
          </Text>
        </Stack>
      </Stack>
    </Modal>
  )
}
